import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageUnPublishMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']>;
}>;

export type ThemePageUnPublishMutationResponse = Pick<Types.Mutation, 'themePageUnPublish'>;

export const ThemePageUnPublishDocument = `
    mutation ThemePageUnPublish($ids: [ID!]!) {
  themePageUnPublish(ids: $ids)
}
    `;

export const useThemePageUnPublishMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePageUnPublishMutationResponse,
    TError,
    ThemePageUnPublishMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePageUnPublishMutationResponse,
    TError,
    ThemePageUnPublishMutationVariables,
    TContext
  >(
    ['ThemePageUnPublish'],
    (variables?: ThemePageUnPublishMutationVariables) =>
      appFetcher<ThemePageUnPublishMutationResponse, ThemePageUnPublishMutationVariables>(
        ThemePageUnPublishDocument,
        variables,
      )(),
    options,
  );
};

useThemePageUnPublishMutation.getKey = () => ['ThemePageUnPublish'];
